export default "__VITE_ASSET__CHzhdeGL__"